module.exports = {
  footerText: 'Copyright © 2020 Green Delta Insurance Limited',
}
